<template>
    <html>
    <body style="background: #f2f2f2" v-loading="loading">
        <!--主体开始-->
        <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/agricultural/index">农技服务</a>&gt; <a href="/agricultural/questionlist">专家问答</a>&gt; <a href="">问答详情</a>
            </div>
        </div>
        <section class="section ncontainer5">
            <div class="neit">
                <div class="wendaxq">
                    <div class="zuo">
                        <div class="xq1 ">
                            <div class="z">
                                <div class="tu"> <img :src="$util.img(expert.image)" alt=""> </div>
                                <ul>
                                    <li>
                                        <img src="@/assets/styles/images/wenda1.png" alt="">
                                        <p>{{expert.name}}·{{expert.title}}</p>
                                    </li>
                                    <!-- <li>
                                        <img src="@/assets/styles/images/wenda2.png" alt="">
                                        <p>陕西省大荔县范家镇</p>
                                    </li> -->
                                    <li>
                                        <img src="@/assets/styles/images/wenda3.png" alt="">
                                        <p>{{expert.unit}}</p>
                                    </li>
                                </ul>
                            </div>
                            <button class="ClickMe" v-if="!expert.isdelete" @click="skip()">去提问</button>
                        </div>
                        <div class="xq2">
                            <ul>
                                <li>
                                    <div class="wen">
                                        <div>
                                            <span>问</span>
                                            <p style="word-break: break-all;">{{model.content}}</p>
                                        </div>
                                        <ul>
                                            <li v-for="item in imageList" :key="item"><img :src="$util.img(item)" alt=""></li>
                                        </ul>
                                        <div class="x1">
                                            <div class="tu"> <img :src="$util.img(member.headimg)" alt=""> </div>
                                            <p>{{ $util.timeStampTurnTime(model.createtime) }}</p>
                                            <button v-if="model.ismine && model.state != -1 && !expert.isdelete" class="btn1" @click="showForm()">继续追问</button>
                                        </div>
                                    </div>
                                    <div class="da" v-for="item in answerList" :key="item.id">
                                        <div class="z">
                                            <div class="tu"> <img :src="item.type == 1 ? $util.img(expert.image) : $util.img(member.headimg)" alt=""> </div>
                                            <div class="y">
                                                <!-- <h2>封涌涛 ·高级农艺师</h2> -->
                                                <h2>{{item.type == 1 ? item.expert.name : item.member.nickname}}</h2> 
                                                <p>{{ $util.timeStampTurnTime(item.createtime) }}</p>
                                            </div>
                                        </div>
                                        <p class="daan" style="word-break: break-all;">{{item.content}}</p>
                                        <ul style="display: flex;flex-direction: row;justify-content: flex-start;align-items: flex-start; flex-wrap: wrap;">
                                            <li style="width:70px;height:70px;margin-right:10px" v-for="item_image in item.answerImgList" :key="item_image"><img :src="$util.img(item_image)" style="width:100%;height:100%;margin-right:10px" alt=""></li>
                                        </ul>
                                        
                                        <!-- <div class="xia">
                                            <div v-if="item.type == 1">
                                                <img src="@/assets/styles/images/zan.png" alt="" class="img1" :id="'img1_'+item.id" @click="dianzan(item.id, 0)"> 
                                                <img src="@/assets/styles/images/zan1.png" :id="'img2_'+item.id" alt="" class="img2" @click="dianzan(item.id, 1)">
                                                <p>有用<span id="useful">{{item.useful}}</span></p>
                                            </div>
                                        </div> -->
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="xq4">
                            <div class="title">
                                <div class="z">
                                    <h2>相关 <span>专家推荐</span></h2>
                                </div>
                                <a href="/agricultural/expertlist"><img src="@/assets/styles/images/more1.png" alt=""> </a>
                            </div>
                            <ul class="zhuanjia">
                                <li v-for="item in expertList" :key='item.id'>
                                    <div class="sh">
                                        <div class="z"><img :src="$util.img(item.image)" alt=""></div>
                                        <div class="y">
                                            <h2>{{item.name}}·{{item.title}} | <a :href="'/agricultural/expertdetails?id='+item.id">详情</a></h2>
                                            <p>{{item.unit}}</p>
                                        </div>
                                    </div>
                                    <div class="zh">
                                        <h2>{{item.askCount}} <span>咨询量</span></h2>
                                        <h2>{{item.answer_rate}}<span>回复率</span></h2>
                                    </div>
                                    <div class="xia">擅长：{{item.expert_in}}</div>
                                    <a :href="'/agricultural/expertdetails?id='+item.id" class="btn">免费提问</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="you">
                        <h2><span>推荐文章</span></h2>
                        <ul>
                            <li v-for="item in recommentList" :key="item.id">
                                <a :href="'/information/details?id='+item.id">
                                    <div class="tu"> <img :src="$util.img(item.image)" alt=""> </div>
                                    <p>{{item.title}}</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <!--提问弹出层-->
        <div id="goodcover"></div>
        <div id="code" style="width: 600px; height: 500px">
        <div class="close"><a href="javascript:void(0)" id="closebt"><img src="@/assets/styles/images/close.png" alt=""></a></div>
        <div class="zixun">
            <h4>继续提问</h4>
            <section class="box-group">
                <section class="item-group item-group-desc">
                    <label> 追问内容 </label>
                    <section class="desc-group">
                        <textarea v-model="data.content" name="desc" placeholder='请详细描述要追问的问题。' maxlength="200"></textarea>
                        <section class='img_box'>
                        <el-upload
                        :action="uploadActionUrl"
                        :limit="imgCount"
                        multiple
                        :on-exceed="handleExceed"
                        list-type="picture-card"
                        accept=".jpg,.jpeg,.png,.gif,.bmp"
                        :on-preview="handlePictureCardPreview"
                        :on-success="handleSuccess"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt=""></el-dialog>
                        <button class='submit_btn' @click="addAnswer()">提交</button>
                        </section>
                    </section>
                </section>
            </section>
        </div>
        </div>
    </body>
</html>
</template>

<script>
    
    import Config from '@/utils/config';
    import { questionDetail } from '@/api/expert/question';
    import { answerList } from '@/api/expert/answer';
    import { addAnswer } from '@/api/expert/answer';
    import { useful } from '@/api/expert/answer';
    import { expertList } from '@/api/expert/expert';
    import { informationList } from '@/api/information/information';
    import { getToken } from "@/utils/auth.js";

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                id: 0,
                model:{},
                expert:{},
                member:{},
                recommentList:[],
                imageList:[],
                answerList:[],
                expertList:[],

                data:{},
                imgCount:9,
                imgList: [],
                dialogImageUrl: '',
			    dialogVisible: false,
                uploadActionUrl: Config.baseUrl + '/api/upload/questionImg',
            };
        },
        created() {
            this.id = this.$route.query.id;
            this.token = getToken();
            this.getdetails();
            this.getanswerList();
            this.getexpertList();
            this.getrecommentList();
        },
        methods: {
            getdetails() {
                questionDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        this.expert = this.model.expert;
                        this.member = this.model.member;
                        if(!util.isEmpty(this.model.image))
                        {
                            this.imageList = this.model.image.split('|');
                        }
                        this.loading = false;
                    }
                }).catch(err => {
                    //this.$message.error(err.message);
                    this.loading = false;
                });
            },
            getanswerList() {
                answerList({
                    qid: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.answerList = res.data;
                        this.answerList.forEach(function(item, i) {
                            item.answerImgList = [];
                            if(!util.isEmpty(item.image)) {
                                item.answerImgList = item.image.split('|');
                            }
                        });
                        console.log(this.answerList);
                    }
                })
            },
            getexpertList() {
                expertList({
                    order: "collection desc",
                    limit: 4
                }).then(res => {
                    if(res.code == 0) {
                        this.expertList = res.data;
                    }
                });
            },
            getrecommentList() {
               informationList({
                    typenumber: "10003",
                    recomment: true,
                    isImg: true,
                    limit: 5
                }).then(res => {
                    if(res.code == 0) {
                        this.recommentList = res.data;
                    }
                });
            },
            addAnswer() {
                if(util.isEmpty(this.token))
                {
                    location.href = '/login?redirect=' + this.$route.fullPath;
                    return;
                }
                if(util.isEmpty(this.data.content))
                {
                    this.$message.warning("请填写追问内容！");
                    return;
                }
                var image = '';
                this.imgList.forEach(item => {
                     image += (!util.isEmpty(image) ? '|' : '') + item.url;
                });
                addAnswer({
                    qid: this.id,
                    content: this.data.content,
                    image: image
                }).then(res => {
                    if(res.code == 0) {
                        this.$message.success("提交成功！");
                        location.reload();
                    }
                    else {
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                });
            },
            dianzan(id, iscancel) {
                if(util.isEmpty(this.token))
                {
                    location.href = '/login?redirect=' + this.$route.fullPath;
                    return;
                }

                var params = {};
                var msg = "点赞成功！";
                if(iscancel == 0) {
                    params = {id:id};
                }
                else {
                    this.isshow = false;
                    params = {id:id, iscancel:1};
                    msg = "取消成功！"
                }

                useful(params).then(res => {
                    if(res.code == 0) {
                        this.$message.success(msg);
                        let idstr1 = '#img1_' + id;
                        let idstr2 = '#img2_' + id;
                        if(iscancel == 0) {
                            $(idstr1).css('display', 'none');
                            $(idstr2).css('display', 'block');
                        }
                        else {
                            $(idstr1).css('display', 'block');
                            $(idstr2).css('display', 'none');
                        }
                    }
                    else {
                        this.$message.warning(res.message);
                    }
                }).catch(err => {
                    this.$message.warning(err.message);
                })
            },
            skip() {
                location.href = "/agricultural/expertdetails?id=" + this.model.eid;
            },
            showForm() {
                if(util.isEmpty(this.token))
                    {
                        this.$message.warning("还未登录，请先登录！");
                        return;
                    }
                    $('#code').center();
                    $('#goodcover').show();
                    $('#code').fadeIn();
            },
            handleSuccess(response, file, fileList){
                var img = {name:response.data.pic_name, url:response.data.pic_path};
                this.imgList.push(img);
                this.checkCount();
            },
            handleRemove(file, fileList) {
                var imgs = [];
                fileList.forEach(item => {
                    var img = this.imgList.filter(function (a) {
                        return a.name == item.name;
                    });  
                    if(img.length >0)
                    {
                        imgs.push(img[0]);
                    }             
                });
                this.imgList = imgs;
                this.checkCount();
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleExceed(file, fileList) {
			    // 图片数量大于9
			    this.$message.error('上传图片最大数量为'+this.imgCount+'张');
		    },
            checkCount() {
                if(this.imgList.length>=this.imgCount){
                    $('.el-icon-plus').parent().hide();
                }
                else {
                    $('.el-icon-plus').parent().show();
                }
            }
        },

        mounted () {

            $(function() {
                $('#closebt').click(function() {
                    $('#code').hide();
                    $('#goodcover').hide();
                });
                $('#goodcover').click(function() {
                    $('#code').hide();
                    $('#goodcover').hide();
                });
                jQuery.fn.center = function(loaded) {
                    var obj = this;
                    var body_width = parseInt($(window).width());
                    var body_height = parseInt($(window).height());
                    var block_width = parseInt(obj.width());
                    var block_height = parseInt(obj.height());

                    var left_position = parseInt((body_width / 2) - (block_width / 2) + $(window).scrollLeft());
                    if (body_width < block_width) {
                        left_position = 0 + $(window).scrollLeft();
                    };

                    var top_position = parseInt((body_height / 2) - (block_height / 2) + $(window).scrollTop());
                    if (body_height < block_height) {
                        top_position = 0 + $(window).scrollTop();
                    };

                    if (!loaded) {

                        obj.css({
                            'position': 'absolute'
                        });
                        obj.css({
                            'top': ($(window).height() - $('#code').height()) * 0.5,
                            'left': left_position
                        });
                        $(window).bind('resize', function() {
                            obj.center(!loaded);
                        });
                        $(window).bind('scroll', function() {
                            obj.center(!loaded);
                        });

                    } else {
                        obj.stop();
                        obj.css({
                            'position': 'absolute'
                        });
                        obj.animate({
                            'top': top_position
                        }, 200, 'linear');
                    }
                }

            });
        },

    }
</script>
<style lang="scss" scoped>

    .btn1{
        width: 180px;
        background: #39bf3e;
        padding: 10px 20px;
        border-radius: 60px;
        color: #fff;
        float: right;
    }
    .bt1:hover {
        box-shadow: 0px 3px 29px 0px rgba(37, 124, 40, 0.67);
        transition: all ease-out 0.5s;
    }

</style>
